import { fadeInUpAnimation } from './../../../shared/services/fade-in-up.animation';
import { ContactService } from './services/contact.service';
import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  animations: [fadeInUpAnimation]
})
export class ContactComponent implements OnInit {
  public formContacto: FormGroup;
  private showScrollHeight = 0;

  constructor(
    @Inject(DOCUMENT) private document:Document,
    private toastr:ToastrService,
    private contactoService: ContactService,
		private fb: FormBuilder,
    private router: Router,) { }

  ngOnInit(): void {
    this.initForm()
  }

  onScrollTop():void{
    this.document.body.scrollTop = 0; // Safari
    this.document.documentElement.scrollTop = 0; // Other
  }

  initForm() {
		this.formContacto = this.fb.group({
			nombre: ['', Validators.compose([
				Validators.required,
			])],
      apellidos: ['', Validators.compose([
				Validators.required,
			])],
      telefono: ['', Validators.compose([
				Validators.required,
			])],
      correo: ['', Validators.compose([
				Validators.required,
				Validators.email,
			])],
      mensaje: ['', Validators.compose([
				Validators.required,
			])],
		})
	}

  onSubmit() {
    this.onScrollTop()
    return this.toastr.success("Tú mensaje ha sido enviado exitosamente", "Correcto!",{
      timeOut: 7000,
    })
  }

  agregar(){
    this.contactoService.agregarContacto(this.formContacto.value).subscribe(
			(response) => {
        this.formContacto.reset()
				this.onScrollTop()
        this.regresar();
        return this.toastr.success("Tú mensaje ha sido enviado exitosamente", "Correcto!",{
          timeOut: 7000,
        })
        
			}, (error) => {
				Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Ocurrio un error al enviar el mensaje!',
        })
        
			}
		);
	}

  regresar() {
		this.router.navigateByUrl('/home/watch');
	}
  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.formContacto.controls[controlName];
    if (!control) {
      return false;
    }
    const result =
      control.hasError(validationType) &&
      (control.dirty || control.touched);
    return result;
  }

}
